var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { TextField } from '../';
/**
 * Extends the TextField component to add features specific to a email input.
 */
const EmailField = (_a) => {
    var rest = __rest(_a, []);
    return (_jsx(TextField, Object.assign({ fullWidth: true, label: "Email", type: "email", autoComplete: "email" }, rest), void 0));
};
export default EmailField;
